import Lib from '../../../commons/lib';

export default class Service {
  static eloadasUrl = window.location.origin + '/api/eloadas/';

  // ELŐADÁS START

  static listEloadas(filters, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.eloadasUrl + 'eloadas/list',
      data: filters,
      params: {image: filters.image}
    }], fnDone);
  }

  static viewEloadas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.eloadasUrl + 'eloadas/view',
      params: { id: id }
    }], fnDone);
  }

  static getEloadas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.eloadasUrl + 'eloadas',
      params: { id: id }
    }], fnDone);
  }

  static addEloadas(eloadas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.eloadasUrl + 'eloadas',
      data: eloadas
    }], fnDone);
  }

  static editEloadas(eloadas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.eloadasUrl + 'eloadas',
      data: eloadas,
      params: { id: eloadas.id }
    }], fnDone);
  }

  static deleteEloadas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.eloadasUrl + 'eloadas',
      params: { id: id }
    }], fnDone);
  }

  static initEloadasForm(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.eloadasUrl + 'eloadas/init',
    }], fnDone);
  }

  static loadMafabData(params, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.eloadasUrl + 'eloadas/import',
      params: params
    }], fnDone);
  }

  static getAngolNyelv(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.eloadasUrl + 'eloadas/angolnyelv',
    }], fnDone);
  }

  // ELŐADÁS END


  // MŰFAJ START

  static listMufajok(param, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.eloadasUrl + 'mufaj/list',
      params: { param : param }
    }], fnDone);
  }

  static addMufaj(mufaj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.eloadasUrl + 'mufaj',
      data: mufaj
    }], fnDone);
  }

  static deleteMufaj(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.eloadasUrl + 'mufaj',
      params: { id: id }
    }], fnDone);
  }

  // MŰFAJ END


  // SZEREPLŐ START

  static listSzereplok(param, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.eloadasUrl + 'szereplo/list',
      params: { param : param }
    }], fnDone);
  }

  static addSzereplo(nev, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.eloadasUrl + 'szereplo',
      params: { nev }
    }], fnDone);
  }

  static deleteSzereplo(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.eloadasUrl + 'szereplo',
      params: { id: id }
    }], fnDone);
  }

  // SZEREPLŐ END


  // KORHATÁR START

  static listKorhatarok(param, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.eloadasUrl + 'korhatar/list',
      params: { param : param }
    }], fnDone);
  }

  static addKorhatar(kod, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.eloadasUrl + 'korhatar',
      params: { kod }
    }], fnDone);
  }

  static deleteKorhatar(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.eloadasUrl + 'korhatar',
      params: { id: id }
    }], fnDone);
  }

  // KORHATÁR END

}
